import { render, staticRenderFns } from "./ForHandle.vue?vue&type=template&id=78fa1d9c&scoped=true&"
import script from "./ForHandle.vue?vue&type=script&lang=js&"
export * from "./ForHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fa1d9c",
  null
  
)

export default component.exports